import React, { useState, useEffect } from 'react'; // Import useEffect
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { CopyToClipboard } from 'react-copy-to-clipboard'; // Import CopyToClipboard
import { useNavigate, useParams } from 'react-router-dom'; // Import useParams
import MapComponent from './MapComponent';
import ShareIcon from "../assets/icons/share.svg";
import FavouriteTrue from "../assets/icons/favouritetrue.svg";
import FavouriteFalse from "../assets/icons/favouritefalse.svg";
import CheckIcon from "../assets/icons/checked.svg"; // Add a checkmark or "copied" icon
import CopyIcon from "../assets/icons/copy.svg"; // Make sure you have the CopyIcon image
import { EmailShareButton, WhatsappShareButton, FacebookShareButton, TwitterShareButton } from "react-share";
import { EmailIcon, WhatsappIcon, FacebookIcon, TwitterIcon } from "react-share";
import { isTokenExpired, getUserIdFromToken } from '../auth/authUtils';
import { ToastContainer, toast } from 'react-toastify'; // Import Toast components
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import MapIcon from '../assets/icons/Maps.svg'
import GridIcon from '../assets/icons/Grid.svg'
import OfficeIcon from '../assets/icons/OfficeList.svg'
import BussinessIcon from '../assets/icons/Bussiness.svg'
import OtherIcon from '../assets/icons/OtherList.svg'
import HomeIcon from '../assets/icons/HomeLIst.svg'

interface Address {
    id: string;
    email: string;
    phoneNumber: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    pinCode: string;
    blockCode: string;
    addressCode: string;
    latitude: number;
    longitude: number;
    userId: string;
    roleId: string;
    createdDate: string;
    updatedDate: string;
    deleteReason?: string;
    deleteStatus?: boolean;
    pamCode: string;
    isFavourite: boolean
    addressType: string;

}
interface UserProfile {
    id: number;
    userName: string;
    email: string;
    phoneNumber: string;
    azureToken: string;
    roleId: number;
    roleName: string;
    createdDate: string;
    updatedDate: string;
    status: string | null;
}

const Favourites: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>(); // Get the address ID from the URL
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [addresses, setAddresses] = useState<any[]>([]); // State to store fetched addresses
    const [viewAsGrid, setViewAsGrid] = useState(false); // Change the default to false to show "View on Map"
    const [addressResults, setAddressResults] = useState<Address[]>([]); // Keep filtered results
    const [copiedPamCode, setCopiedPamCode] = useState<string | null>(null); // State to track copied pamCode
    const [searchData, setSearchData] = useState("");
    const [address, setAddress] = useState<any>(null); // To store a single address's details
    const [errorMessage, setErrorMessage] = useState<string | null>(null); // To store error messages
    const [showDeleteModal, setShowDeleteModal] = useState(false); // Show delete modal
    const [deleteReason, setDeleteReason] = useState(""); // For the delete reason input
    const [addressToDelete, setAddressToDelete] = useState(""); // Store address to be deleted
    const [successMessage, setSuccessMessage] = useState(""); // State for success message
    const [activeSharePamCode, setActiveSharePamCode] = useState<string | null>(null); // Track which pamCode has share options open
    const [userName, setUserName] = useState('');
    const [userProfile, setUserProfile] = useState<UserProfile | null>(null); // Store user profile data
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false); // Modal visibility state
    const [loading, setLoading] = useState(true); // Add loading state

    // Fetch address details when id changes
    // const handleAddressClick = (id: string) => {
    //     // const addressId = pamCode.substring(10); // Get last remaining digits of pamCode
    //     navigate(`/address-details/${id}`);
    // };
    const handleNavigateToGoogleMaps = (latitude: number, longitude: number) => {
        // Construct the Google Maps URL using the query parameter for latitude and longitude
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(googleMapsUrl, '_blank'); // Open in a new tab
    };

    const handleCopy = async (textToCopy: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopiedPamCode(textToCopy);
            setTimeout(() => setCopiedPamCode(null), 2000);
            // Optionally, show a toast notification:
            // toast.success('PAM code copied!');
        } catch (err) {
            console.error('Failed to copy: ', err);
            // Optionally, show an error toast:
            // toast.error('Failed to copy!');
        }
    };



    const HeartClick = async (addressId: any, isFavourite: boolean) => {
        setAddressResults((prevData) =>
            isFavourite ? prevData.map((item) =>
                item.id === addressId ? { ...item, isFavourite: !item.isFavourite } : item
            )
                : prevData.filter((item) => item.id !== addressId)

        );


        const token = localStorage.getItem('token');

        if (!token) {
            console.error('Token not found. User might be logged out.');
            return;
        }

        try {
            if (isFavourite) {
                // POST request to add to favourites
                const apiUrl = 'http://192.168.7.108:7448/api/AddressFavourites';
                const payload = {
                    addressId,
                    isFavourite: true,
                };

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    revertFavouriteState(addressId, isFavourite);
                    return;
                }

                //console.log('Successfully added to favourites.');
            }
            else {
                // DELETE request to remove from favourites
                // const apiUrl = `http://192.168.7.108:7448/api/AddressFavourites?addressId=${addressId}`;
                const apiUrl = `https://pamsapi.vofoxsolutions.com/api/AddressFavourites/RemoveFromFavouritesAsync?addressId=${addressId}`;

                const response = await fetch(apiUrl, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    console.error('Failed to remove from favourites:', response.status, response.statusText);
                    revertFavouriteState(addressId, isFavourite);
                    return;
                }

                //console.log('Successfully removed from favourites.');
            }
        } catch (error) {
            console.error('An error occurred while updating favourite status:', error);
            revertFavouriteState(addressId, isFavourite);
        }
    };



    // Helper function to revert the favourite state in case of an error
    const revertFavouriteState = (addressId: number, originalState: boolean) => {
        setAddresses((prevData) =>
            prevData.map((item) =>
                item.id === addressId ? { ...item, isFavourite: originalState } : item
            )
        );
    };

    useEffect(() => {
        const storedUserName = localStorage.getItem('userName');
        // console.log('Retrieved UserName from localStorage:', storedUserName); // Check what is retrieved
        if (storedUserName) {
            setUserName(storedUserName);
        }
        const handleStorageChange = () => {
            const updatedUserName = localStorage.getItem('userName');
            if (updatedUserName) {
                setUserName(updatedUserName);

            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);

        };
    }, []);
    const fetchUserProfile = async () => {
        const token = localStorage.getItem("token"); // Get the stored token
        if (!token) {
            console.error('Token not found in localStorage');
            setErrorMessage('Session expired. Please log in again.');
            navigate('/home'); // Redirect to login page
            return; // Stop execution if token is not found
        }

        try {


            const response = await fetch('https://pamsapi.vofoxsolutions.com/api/User/GetUserProfile', {
                //const response = await fetch('http://192.168.7.108:7448/api/User', {

                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`, // Add token to Authorization header
                    "Content-Type": "application/json", // Ensure Content-Type is set
                },
            });

            // console.log('Response Status:', response.status); // Log the response status

            if (!response.ok) {
                throw new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`);
            }

            const data: UserProfile = await response.json();
            // console.log('Fetched User Profile:', data); // Log the fetched user profile
            setUserProfile(data); // Save user profile to state
            setUserName(data.userName); // Update the username state
            updateUserName(data.userName); // Update the username in the parent component

            setIsProfileModalOpen(false); // Open the profile modal

            // Pass user profile data via navigate to profile page
            navigate('/profile', {
                state: {
                    userName: data.userName,
                    email: data.email,
                    phoneNumber: data.phoneNumber,
                },
            });
        } catch (error) {
            console.error('Error fetching user profile:', error);
            toast.error("An error occurred while fetching user profile.");
        }
    };

    const handleShareClick = (pamCode: string) => {
        if (activeSharePamCode === pamCode) {
            setActiveSharePamCode(null); // Close share options if the same pamCode is clicked again
        } else {
            setActiveSharePamCode(pamCode); // Open share options for the clicked pamCode
        }
    };


    const shareMessage = (address: Address) => {
        return `Check out this address:\n${address?.addressLine1}, ${address?.addressLine2}, ${address?.addressLine3}\nPincode: ${address?.pinCode}\nPAM Code: ${address?.pinCode + address?.blockCode + address?.addressCode}`;
    };

    // Helper function to format pamCode
    const formatPamCode = (pamCode: string) => {
        if (!pamCode) return "N/A"; // Handle null or undefined pamCode

        // Assuming pamCode follows the format: 6820170000117 (pincode + blockcode + addresscode)
        const pincode = pamCode.slice(0, 6); // First 6 characters as pincode
        const blockCode = pamCode.slice(6, 10); // Next 4 characters as block code
        const addressCode = pamCode.slice(10); // Remaining characters as address code

        return `${pincode}-${blockCode}-${addressCode}`; // Format as pincode-blockcode-addresscode
    };



    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    // Fetch addresses when "View as grid" is clicked
    const fetchAddresses = async () => {
        const token = localStorage.getItem('token');
        // console.log('Token from localStorage:', token);

        if (!token) {
            console.error('Token not found in localStorage');
            toast.error('Session expired. Please log in again.');
            navigate('/'); // Redirect to login page
            return; // Stop execution if token is not found
        }

        try {
            const response = await fetch('https://pamsapi.vofoxsolutions.com/api/AddressFavourites/GetFavouriteAddressesAsync', {
                //const response = await fetch('http://192.168.7.108:7448/api/AddressFavourites', {

                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });


            if (!response.ok) {
                if (response.status === 401) {
                    toast.error('Session expired or unauthorized. Please log in again.');
                    navigate('/'); // Redirect to login page
                } else if (response.status !== 404) {
                    // Avoid showing error toast for status 404 or other benign cases
                    toast.error('Failed to fetch addresses. Please try again.');
                }
                return;
            }

            const data = await response.json();
            // console.log('Fetched Addresses:', data);

            if (data.length === 0) {
                // toast.info('No addresses found.');
            }

            setAddresses(data);
            setAddressResults(data); // Populate the grid or map with these addresses
        } catch (error) {
            console.error('Error fetching addresses:', error);
            // toast.error('An unexpected error occurred. Please try again.');
        } finally {
            setLoading(false); // Set loading to false after fetching addresses
        }
    };

    const handleLogout = () => {
        // Clear user session (localStorage, sessionStorage, or cookies)
        localStorage.removeItem('userToken'); // Example: remove the user token or session info
        sessionStorage.clear(); // Clear sessionStorage if needed
        // You can also clear cookies if used for session management

        // Redirect to the Register page
        navigate('/'); // Redirects to localhost:3000/register
    };
    useEffect(() => {
        fetchAddresses();
    }, []);
    // Empty dependency array ensures this only runs once when the component mounts

    // Filter addresses based on searchData
    useEffect(() => {
        const filteredAddresses = addresses.filter(address =>
            address.addressLine1.toLowerCase().includes(searchData.toLowerCase()) ||
            address.addressLine2.toLowerCase().includes(searchData.toLowerCase()) ||
            address.addressLine3.toLowerCase().includes(searchData.toLowerCase()) ||
            address.pinCode.toLowerCase().includes(searchData.toLowerCase())
        );
        setAddressResults(filteredAddresses);
    }, [searchData, addresses]);
    const initialPosition = addressResults.length > 0
        ? [addressResults[0].latitude, addressResults[0].longitude]
        : [40.7128, -74.0060]; // Default to NYC

    // Add this skeleton loader component


    return (
        <div className="bg-slate-100 flex flex-col pl-4 justify-between min-h-screen relative pt-16 mt-2 min-w-60">      <ToastContainer />
            <header className='flex items-center fixed top-0 right-4 left-5 z-10 justify-between px-6 py-1 bg-white'>
                <h1 className='text-lg font-semibold'></h1>
                <div className="flex justify-end items-center gap-6">
                    {/* Bell Icon */}
                    <div className="relative">
                        {/* <img src={} alt="Notifications" className="w-6 h-6 cursor-pointer" /> */}
                        {/* Optionally add a notification count indicator */}

                    </div>

                    {/* User Profile Dropdown */}
                    <div className="relative m-3">
                        <button
                            onClick={toggleDropdown}
                            className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
                        >
                            <div className="w-8 h-8 overflow-hidden rounded-full">
                                <img
                                    className="object-cover w-full h-full"
                                    src="https://cdn-icons-png.flaticon.com/128/18573/18573514.png"
                                    alt="User Avatar"
                                />
                            </div>
                            <h1>{userName || 'Guest'}</h1>          </button>

                        {dropdownOpen && (
                            <>
                                {/* Close dropdown when clicking outside */}
                                <div
                                    onClick={() => setDropdownOpen(false)}
                                    className="fixed inset-0 z-10 w-full h-full"
                                ></div>

                                {/* Dropdown menu */}
                                <div className="absolute right-0 z-20 w-48 mt-2 bg-white rounded-md shadow-xl">
                                    <button
                                        onClick={fetchUserProfile}
                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                                    >
                                        Profile
                                    </button>
                                    {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white">
                  Products
                </a> */}
                                    <button
                                        onClick={handleLogout}
                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                                    >
                                        Log out
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                </div>
            </header>
            <main className="flex-1 mt-6">
                <div>
                    <h1 className="text-base sm:text-lg text-dark font-semibold mt-2">Favourites</h1>


                    <div className="container py-4 mx-auto bg-transparent m-1 rounded-lg">
                        <div className="flex justify-between items-center ">
                            <div className="rounded-lg shadow-shadow1 w-auto border bg-white border-white">
                                <ul className="relative flex flex-wrap px-2.5 py-3.5 list-none rounded-md bg-white " data-tabs="tabs" role="list">

                                    <li className=" flex-auto text-center">
                                        <a
                                            className={` flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border border-white rounded-md cursor-pointer ${!viewAsGrid ? 'border-white  text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'
                                                }`}
                                            role="tab"
                                            aria-selected={viewAsGrid}
                                            onClick={() => setViewAsGrid(false)}
                                        >
                                            <img src={GridIcon} alt="View as Grid" className="w-4 h-4 mr-1.5" />
                                            <span className="ml-1">Details</span>
                                        </a>
                                    </li>
                                    <li className=" flex-auto text-center mr-2">
                                        <a
                                            className={` flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border
                                                           border-white rounded-md cursor-pointer ${viewAsGrid ? 'border-white  text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'}`}
                                            role="tab"
                                            aria-selected={!viewAsGrid}
                                            onClick={() => setViewAsGrid(true)}
                                        >
                                            <img src={MapIcon} alt="View on Map" className="w-4 h-4 mr-1.5" />
                                            <span className="ml-1">Map</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>




                        </div>
                    </div>




                    {errorMessage && <div className="text-red-500">{errorMessage}</div>}
                    {successMessage && <div className="text-green-500">{successMessage}</div>}

                    {!viewAsGrid ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-lg bg-white shadow-shadow1 w-auto p-4 mb-14 ">
                            {addressResults.length > 0 ? (
                                addressResults.map((address, index) => (
                                    <div
                                        key={address.id || index}
                                        className="relative border p-3  rounded-md shadow-sm cursor-pointer  hover:border-blue-500" // Add hover:border-blue-500
                                        onClick={(e) => {
                                            const target = e.target as HTMLElement; // Cast e.target to HTMLElement
                                            if (!target.closest('button')) { // Now you can use closest()
                                                if (address.latitude && address.longitude) {
                                                    handleNavigateToGoogleMaps(address.latitude, address.longitude);
                                                } else {
                                                    toast.error("Location not available for this address");
                                                }
                                            }
                                        }}
                                    >

                                        <div className="grid grid-cols-12 items-center">
                                            <div className="text-sm col-span-9 gap-2 md:text-base font-medium text-gray-700  flex items-center">
                                                {address.addressType.toLowerCase() === 'office' && (
                                                    <>
                                                        <img
                                                            src={OfficeIcon}
                                                            alt="Office Icon"
                                                            className="w-8 h-8 mr-2"
                                                        />
                                                        Office
                                                    </>
                                                )}
                                                {/* {address.addressType.toLowerCase() === 'business' && (
                                                    <>
                                                        <img
                                                            src={BussinessIcon}
                                                            alt="Business Icon"
                                                            className="w-6 h-6 mr-2 rounded-full ring-1 ring-offset-4 ring-green-500"
                                                        />
                                                        Business
                                                    </>
                                                )} */}
                                                {address.addressType.toLowerCase() === 'home' && (
                                                    <>
                                                        <img
                                                            src={HomeIcon}
                                                            alt="Home Icon"
                                                            className="w-8 h-8 mr-2 "
                                                        />
                                                        Home
                                                    </>
                                                )}
                                                {address.addressType.toLowerCase() === 'other' && (
                                                    <>
                                                        <img
                                                            src={OtherIcon}
                                                            alt="Other Icon"
                                                            className="w-8 h-8 mr-2 "
                                                        />
                                                        Other
                                                    </>
                                                )}
                                                {!['office', 'home', 'other'].includes(address.addressType.toLowerCase()) && (
                                                    <>
                                                        <img
                                                            src={OtherIcon}
                                                            alt="Custom Type Icon"
                                                            className="w-8 h-8 mr-2 "
                                                        />
                                                        {address.addressType}
                                                    </>
                                                )}
                                            </div>

                                            <div className="col-span-3 flex items-center gap-2 justify-end">

                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const pamCode = `${address.pinCode}${address.blockCode}${address.addressCode}`;
                                                        handleShareClick(pamCode); // Pass pamCode here
                                                    }}
                                                    title="Share"
                                                    className="p-1 border border-[#D6DFFE] bg-[#D6DFFE] rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0"
                                                >

                                                    <img src={ShareIcon} alt="Share" className="w-4 h-4" />
                                                </button>
                                                {activeSharePamCode === `${address.pinCode}${address.blockCode}${address.addressCode}` && (
                                                    <div className="absolute top-8 right-0 z-20 p-4 bg-white shadow-lg rounded-lg border border-gray-200 flex gap-4 mt-2 transform scale-105">
                                                        <EmailShareButton
                                                            url={shareMessage(address)}
                                                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                                                        >
                                                            <EmailIcon size={32} round />
                                                        </EmailShareButton>
                                                        <WhatsappShareButton
                                                            url={shareMessage(address)}
                                                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                                                        >
                                                            <WhatsappIcon size={32} round />
                                                        </WhatsappShareButton>
                                                        <FacebookShareButton
                                                            url={shareMessage(address)}
                                                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                                                        >
                                                            <FacebookIcon size={32} round />
                                                        </FacebookShareButton>
                                                        <TwitterShareButton
                                                            url={shareMessage(address)}
                                                            className="transform transition-transform duration-300 hover:scale-125 hover:shadow-xl"
                                                        >
                                                            <TwitterIcon size={32} round />
                                                        </TwitterShareButton>
                                                    </div>
                                                )}
                                                <button
                                                    onClick={(e) => {
                                                        // e.stopPropagation(); // Prevent navigating to AddressDetails
                                                        // handleDelete(address.id); // Show delete modal
                                                    }}
                                                    title="Favourites"
                                                    className="p-1 border border-[#D6DFFE] bg-[#D6DFFE] rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0"

                                                >
                                                    <img
                                                        src={address.isFavourite ? FavouriteFalse : FavouriteTrue}
                                                        alt="Favourites"
                                                        className="w-4 h-4"
                                                        onClick={() => HeartClick(Number(address.id), address.isFavourite)}
                                                    />


                                                </button>

                                            </div>
                                            <p className="text-sm order-1 col-span-12 md:text-base font-medium text-gray-700 mt-4">
                                                Address: {address.addressLine1}, {address.addressLine2}, {address.addressLine3}
                                            </p>
                                        </div>
                                        <p className="text-sm text-gray-600">Pincode: {address.pinCode}</p>
                                        <p className="text-sm text-gray-600 mb-2">PamCode:</p>
                                        {/* Textbox with Copy Icon */}
                                        <div className="relative">
                                            <input
                                                type="text"
                                                className="w-full p-2 border rounded-md"
                                                value={formatPamCode(address.pinCode + address.blockCode + address.addressCode)}
                                                readOnly
                                            />
                                            <button
                                                className="absolute right-3 top-2 transform text-gray-500 hover:text-blue-500"
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent any parent click events (like redirection)
                                                    handleCopy(address.pinCode + address.blockCode + address.addressCode);
                                                }}
                                            >
                                                {copiedPamCode === (address.pinCode + address.blockCode + address.addressCode) ? (
                                                    <img src={CheckIcon} alt="Copied" className="w-6 h-6" />
                                                ) : (
                                                    <img src={CopyIcon} alt="Copy" className="w-6 h-6" />
                                                )}
                                            </button>

                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-gray-500">No favourites added yet—get started by adding some!</p>
                            )}

                        </div>
                    ) : (
                        <div className="p-3 mx-auto  bg-white m-0 rounded-lg h-500px w-[100%]">
                            {/* <h3 className="text-lg text-gray-700 font-semibold mb-4">Map View</h3> */}
                            <div className="w-full overflow-hidden" style={{ height: 'calc(100vh - (250px))' }}>
                                <MapComponent addresses={addresses} showLocateControl={false} />
                            </div>
                        </div>
                    )}

                    {/* {showDeleteModal && (
                        <div
                            className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[1000]" // Add a high z-index here
                        >
                            <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
                                <h2 className="text-xl font-bold mb-4">Delete Address</h2>
                                <p>Are you sure you want to delete this address?</p>
                                <textarea
                                    className="w-full mt-4 p-2 border border-gray-300 rounded-md"
                                    placeholder="Enter delete reason..."
                                    value={deleteReason}
                                    onChange={(e) => setDeleteReason(e.target.value)}
                                />
                                <div className="mt-4 flex justify-between">
                                    <button
                                        className="px-4 py-2 bg-gray-400 text-white rounded-md"
                                        onClick={() => setShowDeleteModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-red-600 text-white rounded-md"
                                        onClick={handleDeleteSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>


                    )} */}


                </div>
            </main>
            <div className="mt-3 bottom-20 w-full bg-white shadow-shadow1 rounded-md border">
                <div className="px-8 py-4">
                    <p className="text-center text-jetgrey text-sm">
                        GET ME THERE. © 2024
                    </p>
                </div>
            </div>


        </div>
    );
};

export default Favourites;
